<template>
    <div :ref="ref">

    </div>
</template>
<script>
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/theme/vintage";
import { util } from "@/libs";
export default {
  props: { option: { required: true }, type: { default: "bar" } },
  data() {
    return {
      ref: util.uuid()
    };
  },
  methods: {
    echarts(data,type){
        var colors = ['#5793f3', '#1E90FF', '#675bba']
        if(!type){
            return {
                backgroundColor: data.backgroundColor,
                title:{
                    text: data.title,
                    x:'center',
                    textStyle:{
                        fontWeight:'normal',
                        color: '#fff'
                    }
                },
                color: colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',   //shadow,cross
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        dataView : {show: true, readOnly: false},
                        magicType : {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                        restore : {show: true},
                        saveAsImage : {show: true}
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : data.x,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    }
                ],
                yAxis : [
                    {
                        type : 'value'
                    }
                ],
                series : [
                    {
                        name:data.text,
                        type:'bar',
                        barWidth: '40%',
                        data:data.y
                    }
                ]
            }
        }else if(type==1){
            return {
                  title:{
                    text: data.title,
                    textAlign:'center',
                    left:'50%',
                    textStyle:{
                        fontWeight:'normal'
                    }
                },
                tooltip : {
                    trigger: 'axis'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        dataView : {show: true, readOnly: false},
                        magicType : {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                        restore : {show: true},
                        saveAsImage : {show: true}
                    }
                },
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : data.x
                    }
                ],
                yAxis : [
                    {
                        type : 'value'
                    }
                ],
                series : [
                    {
                        name:data.text,
                        type:'line',
                        stack: '总量',
                        itemStyle: {normal: {areaStyle: {type: 'default'}}},
                        data:data.y
                    },
                    
                ]
            };
        }else if(type==2){
            var arr = [];
            for(var i in data.x){
                arr.push({value:data.y[i],name:data.x[i]})
            }

            return  {
                tooltip : {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        dataView : {show: true, readOnly: false},
                        magicType : {
                            show: true, 
                            type: ['pie', 'funnel'],
                            option: {
                                funnel: {
                                    x: '25%',
                                    width: '50%',
                                    funnelAlign: 'center',
                                    max: 1548
                                }
                            }
                        },
                        restore : {show: true},
                        saveAsImage : {show: true}
                    }
                },
                calculable : true,
                series : [
                    {
                        name:data.text,
                        type:'pie',
                        radius : ['50%', '70%'],
                        itemStyle : {
                            normal : {
                                label : {
                                    show : false
                                },
                                labelLine : {
                                    show : false
                                }
                            },
                            emphasis : {
                                label : {
                                    show : true,
                                    position : 'center',
                                    textStyle : {
                                        fontSize : '30',
                                        fontWeight : 'bold'
                                    }
                                }
                            }
                        },
                        data:arr
                    }
                ]
            };
        }
    }
  },
  mounted() {
      const myChart = echarts.init(this.$refs[this.ref], "vintage")
      myChart.setOption(this.$props.option)
  },
  created() {
  }
};
</script>